// import { configureStore } from "@reduxjs/toolkit";
// import driverSlice from "./driverSlice";
// import productSlice from "./productSlice";
// import vendorSlice from "./vendorSlice";
// import stockSlice from "./stockSlice";
// import dplistSlice from "./dplistSlice";

// const store = configureStore({
//   reducer: {
//     drivers: driverSlice,
//     products: productSlice,
//     vendors: vendorSlice,
//     stocks: stockSlice,
//     dplist: dplistSlice,
//   },
// });

// export default store;

import { configureStore } from "@reduxjs/toolkit";
import driverSlice from "./driverSlice";
import productSlice from "./productSlice";
import vendorSlice from "./vendorSlice";
import stockSlice from "./stockSlice";
import dplistSlice from "./dplistSlice";
import godownSlice from "./godownSlice";
import vehiclSlice from "./vehiclSlice";
import customerSlice from "./customerSlice";
import orderSlice from "./orderSlice";
import receiptReducer from "./receiptSlice";
import inventorySlice from "./inventorySlice";
import purchaseSlice from "./purchaseSlice";
import quotationReducer from "./quotationSlice";
import purchaseReducer from "./purchaseOrderSlice"
import bankReducer from "./bankSlice";
import bankReportReducer from "./bankReportSlice";
import defectiveReturnReducer from "./DefectiveSlice";
import ticketReducer from "./ticketSlice";
import paymentRefundReducer from "./paymentRefundSlice";
import creditReducer from "./creditSlice";
import equipmentReducer from "./EquipmentSlice";
import otpReducer from "./OtpSlice";
import depositReducer from "./SecurityDepositSlice"
import notificationReducer from "./NotificationSlice";
import receiptsReducer from "./ReceiptNewSlice";
import couponReducer from "./couponSlice";
import loanReducer from "./LoanSlice";
const store = configureStore({
  reducer: {
    drivers: driverSlice,
    products: productSlice,
    vendors: vendorSlice,
    stocks: stockSlice,
    dplist: dplistSlice,
    godown: godownSlice,
    vehicles: vehiclSlice,
    customers: customerSlice,
    orders: orderSlice,
    inventory: inventorySlice,
    purchase: purchaseSlice,
    receipt: receiptReducer, 
    quotation:quotationReducer,
    purchaseOrder:purchaseReducer,
    banks:bankReducer,
    bankReports:bankReportReducer,
    defectiveReturns: defectiveReturnReducer,
    tickets: ticketReducer,
    paymentRefund: paymentRefundReducer,
    credit: creditReducer,
    equipment:equipmentReducer,
    otp:otpReducer,
    sd_deposit:depositReducer,
    notifications:notificationReducer,
    receipts:receiptsReducer,
    coupon:couponReducer,
    loan:loanReducer,
  },
});

export default store;
